import React, { useState } from 'react';
import { ZohoOrganizationModal } from './ZohoOrganizationModal';

interface IntegrationStatusBadgesProps {
	integrations: {
		zoho: {
			enabled: boolean;
			configured: boolean;
			lastSync?: string;
			organizationId?: string;
			organizationName?: string;
		};
		odoo: { enabled: boolean; configured: boolean; lastSync?: string };
		msd: { enabled: boolean; configured: boolean; lastSync?: string };
	};
	clientId: string;
}

export const IntegrationStatusBadges: React.FC<IntegrationStatusBadgesProps> = ({ integrations, clientId }) => {
	const [showOrgModal, setShowOrgModal] = useState(false);

	const handleZohoSetup = (clientId: string) => {
		window.open(`/api/auth/zoho/connect/${clientId}`, '_blank');
	};

	const getIntegrationBadge = (enabled: boolean, configured: boolean, integrationType: 'zoho' | 'odoo' | 'msd') => {
		if (!enabled) {
			return <span className="text-xs text-gray-500">Disabled</span>;
		}

		if (!configured) {
			if (integrationType === 'zoho') {
				return (
					<button
						onClick={() => handleZohoSetup(clientId)}
						className="text-xs text-yellow-600 hover:text-yellow-700 hover:underline cursor-pointer">
						Setup Required
					</button>
				);
			}
			return <span className="text-xs text-yellow-600">Setup Required</span>;
		}

		if (integrationType === 'zoho') {
			const orgName = integrations.zoho.organizationName;
			return (
				<div className="flex flex-col gap-0.5">
					<div className="flex items-center space-x-2">
						<span className="text-xs text-green-600">Active</span>
						<button
							onClick={() => setShowOrgModal(true)}
							className="text-xs text-blue-600 hover:text-blue-700 hover:underline cursor-pointer"
							title="Switch Organization">
							Switch Org
						</button>
					</div>
					{orgName && (
						<span className="text-xs text-gray-400 truncate max-w-[160px]" title={orgName}>
							{orgName}
						</span>
					)}
				</div>
			);
		}

		return <span className="text-xs text-green-600">Active</span>;
	};

	return (
		<div className="space-y-1">
			<div className="flex items-center space-x-2">
				<span className="text-xs text-gray-500">Zoho:</span>
				{getIntegrationBadge(integrations.zoho.enabled, integrations.zoho.configured, 'zoho')}
			</div>
			<div className="flex items-center space-x-2">
				<span className="text-xs text-gray-500">Odoo:</span>
				{getIntegrationBadge(integrations.odoo.enabled, integrations.odoo.configured, 'odoo')}
			</div>
			<div className="flex items-center space-x-2">
				<span className="text-xs text-gray-500">MSD:</span>
				{getIntegrationBadge(integrations.msd.enabled, integrations.msd.configured, 'msd')}
			</div>

			<ZohoOrganizationModal
				isOpen={showOrgModal}
				onClose={() => setShowOrgModal(false)}
				clientId={clientId}
				currentOrgId={integrations.zoho.organizationId}
			/>
		</div>
	);
};
